<template>
  <div class="GeneralFiscal" :style="colapseFiscal && 'overflow: hidden'">
    <div class="carroselCtn">
      <div class="StatementOnAccount">
        <label
          v-for="item in tabs"
          :key="item.text"
          class="StatementOnAccountItem"
          :class="{ active: selectedTabLabel === item.value }"
          @click="storeLabelTabName(item.value)"
        >
          {{ item.text }}
        </label>
      </div>
    </div>
    <div class="ContainerNotes" v-if="selectedTabLabel === 'nfe'">
      <div class="headerGeneralSales">
        <div
          style="
            display: flex;
            width: 100%;
            justify-content: space-between;
            align-items: center;
            background: white;
            border-radius: 5px;
          "
        >
          <b-button class="BtnRegister">
            <b-icon-plus
              scale="1.5"
              @click.stop="handleModals('nfe')"
              style="
                width: 30px;
                background: #006458;
                height: 30px;
                color: white;
                border-radius: 3px;
              "
            ></b-icon-plus>
            <span style="width: calc(100% - 30px)">Nova NF-e</span>
          </b-button>

          <div class="searchContainer">
            <div class="searchInput">
              <b-form-select
                class="searchFilter"
                size="sm"
                value-field="value"
                text-field="text"
                v-model="type"
                :options="filterCombobox"
              ></b-form-select>

              <div v-if="type === 'status'">
                <b-form-select
                  class="searchFilterSituation"
                  value-field="value"
                  text-field="text"
                  v-model="textPesquisa"
                  :options="filterSituationCombobox"
                  @change="filterNota"
                ></b-form-select>
              </div>

              <div v-else>
                <b-input
                  class="inputSearch"
                  placeholder="Pesquisar por..."
                  v-model="textPesquisa"
                  @keyup.enter="searchOrClear(page)"
                ></b-input>
              </div>
            </div>
            <div class="lineSearch">
              <div class="summaryMonth">
                Resumo: &nbsp;
                <strong>{{
                  selectTextDate === "Personalizado"
                    ? ""
                    : `(${selectTextDate})`
                }}</strong>
              </div>
              <div class="pagMonth"></div>
              <div
                class="searchInput"
                style="
                  padding: 0px !important;
                  display: flex;
                  justify-content: space-between;
                "
                v-if="selectTextDate === 'Personalizado'"
              >
                <button class="btnPeriod" size="sm">Período</button>
                <div class="dateInput">
                  <input
                    type="date"
                    id="date"
                    v-model="startDate"
                    style="
                      padding: 0.25rem 0.25rem 0.25rem 0.5rem;
                      cursor: pointer;
                      border-left: none;
                      width: 130px;
                      border-radius: 0px 5px 5px 0px;
                    "
                  />
                  <input
                    type="date"
                    id="date"
                    v-model="endDate"
                    style="
                      padding: 0.25rem 0.25rem 0.25rem 0.25rem;
                      cursor: pointer;
                      width: 130px;
                      border-right: none;
                      border-radius: 5px 0 0 5px;
                    "
                  />
                </div>
                <b-button
                  size="sm"
                  @click="searchOrClear(page)"
                  class="searchBtn"
                >
                  <b-icon-search></b-icon-search>
                </b-button>
              </div>

              <div style="width: 25px">
                <DropdownFilters @handleFilterDays="handleFilterDays" />
              </div>
            </div>
          </div>

          <div class="BtnCounter">
            <b-icon-coin></b-icon-coin>
            <span>NF-e Emitidas - </span>
            <span> {{ maskCurrency(this.totalNfe) }} </span>
          </div>
        </div>
      </div>
      <div class="generalContainer">
        <div class="rowProvisionService">
          <div class="ContentTable" v-if="tableActive.nfe">
            <div class="headerTable">
              <div class="celTable" style="width: 10%">Data</div>
              <div class="celTable" style="width: 13%">Origem</div>
              <div class="celTable" style="width: 13%">Tipo</div>
              <div class="celTable" style="width: 10%">Nº</div>
              <div class="celTable" style="width: 27%">Cliente</div>
              <div class="celTable" style="width: 10%">Status</div>
              <div class="celTable" style="width: 10%">Valor</div>
              <div class="celTableActions">Ações</div>
            </div>
            <div
              v-for="dataSearchNota in dataNota"
              :key="dataSearchNota.id"
              :class="`rowSupplier`"
              @click.stop="editNfe(dataSearchNota.id)"
            >
              <div class="celTable" style="width: 10%">
                {{ dataSearchNota.data | moment }}
              </div>
              <div
                class="celTable"
                style="width: 13%"
                v-if="dataSearchNota.numVenda"
              >
                Venda N°{{ dataSearchNota.numVenda }}
              </div>
              <div class="celTable" style="width: 13%" v-else>--</div>
              <div class="celTable" style="width: 13%">
                {{ formatSaleType(dataSearchNota.typeSale) }}
              </div>
              <div
                class="celTable"
                style="width: 10%"
                v-if="dataSearchNota.response"
              >
                {{ dataSearchNota.response.nfe || "______" }}
              </div>
              <div class="celTable" style="width: 10%" v-else>--</div>
              <div
                class="celTable"
                style="width: 27%; font-weight: 600; text-transform: uppercase"
              >
                {{ dataSearchNota.nomeCliente || "______" }}
              </div>
              <div
                class="celTable"
                style="
                  color: #3e66ae;
                  width: 9%;
                  background-color: #ddebff;
                  border-radius: 8px;
                "
                v-if="dataSearchNota.status === 'Emitida'"
              >
                {{ dataSearchNota.status }}
              </div>
              <div
                class="celTable"
                style="
                  color: #ff5454;
                  width: 9%;
                  background-color: #ffcfc9;
                  border-radius: 8px;
                "
                v-else-if="dataSearchNota.status === 'Cancelada'"
              >
                {{ dataSearchNota.status }}
              </div>
              <div
                v-else
                class="celTable"
                style="
                  color: #4a4a4a;
                  width: 9%;
                  background-color: #d4d4d4;
                  border-radius: 8px;
                "
              >
                {{ dataSearchNota.status }}
              </div>
              <div class="celTable" style="width: 10%">
                {{
                  maskCurrency(
                    dataSearchNota.total +
                      (dataSearchNota.despesas_acessorias || 0) || 0
                  )
                }}
              </div>
              <div class="celTableActions">
                <div class="btnActions">
                  <b-dropdown
                    id="dropdown-1"
                    text="Ações"
                    menu-class="w-1"
                    class="btnActions"
                    size="sm"
                    variant="none"
                  >
                    <template #button-content>
                      <b-icon-gear-fill
                        class="contentActions"
                      ></b-icon-gear-fill>
                    </template>
                    <b-dropdown-item
                      @click.stop="getIdDocumentoToDelete(dataSearchNota.id)"
                    >
                      Excluir
                    </b-dropdown-item>

                    <b-dropdown-item
                      v-if="dataSearchNota.status === 'Corrigida'"
                      @click.stop="
                        openPdf(dataSearchNota.response_carta_correcao.dacce)
                      "
                    >
                      Imprimir Correção
                    </b-dropdown-item>

                    <b-dropdown-item
                      @click.stop="findDetails(dataSearchNota.id)"
                      v-b-modal.modal-center2
                      v-if="dataSearchNota.status !== 'Não Enviada'"
                    >
                      Detalhes
                    </b-dropdown-item>

                    <b-dropdown-item
                      @click.stop="duplicate(dataSearchNota.id)"
                      v-if="
                        !dataSearchNota.idVenda || !dataSearchNota.idVendaMtq
                      "
                    >
                      Duplicar
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ContainerNotes" v-if="selectedTabLabel === 'nfce'">
      <div class="headerGeneralSales">
        <div
          style="
            display: flex;
            width: 100%;
            justify-content: space-between;
            align-items: center;
            background: white;
            border-radius: 5px;
          "
        >
          <b-button class="BtnRegister">
            <b-icon-plus
              scale="1.5"
              @click.stop="handleModals('nfce')"
              style="
                width: 30px;
                background: #006458;
                height: 30px;
                color: white;
                border-radius: 3px;
              "
            ></b-icon-plus>
            <span style="width: calc(100% - 30px)">Nova NFC-e</span>
          </b-button>
          <div class="searchContainer">
            <div class="searchInput">
              <b-form-select
                class="searchFilter"
                size="sm"
                value-field="value"
                text-field="text"
                v-model="type"
                :options="filterCombobox"
              ></b-form-select>
              <div>
                <b-input
                  class="inputSearch"
                  placeholder="Pesquisar por..."
                  v-model="textPesquisa"
                  @keyup.enter="searchOrClear(page)"
                ></b-input>
              </div>
            </div>
            <div class="lineSearch">
              <div class="summaryMonth">
                Resumo: &nbsp;
                <strong>{{
                  selectTextDate === "Personalizado"
                    ? ""
                    : `(${selectTextDate})`
                }}</strong>
              </div>
              <div class="pagMonth"></div>
              <div
                class="searchInput"
                style="
                  padding: 0px !important;
                  display: flex;
                  justify-content: space-between;
                "
                v-if="selectTextDate === 'Personalizado'"
              >
                <button class="btnPeriod" size="sm">Período</button>
                <div class="dateInput">
                  <input
                    type="date"
                    id="date"
                    v-model="startDate"
                    style="
                      padding: 0.25rem 0.25rem 0.25rem 0.5rem;
                      cursor: pointer;
                      border-left: none;
                      width: 130px;
                      border-radius: 0px 5px 5px 0px;
                    "
                  />
                  <input
                    type="date"
                    id="date"
                    v-model="endDate"
                    style="
                      padding: 0.25rem 0.25rem 0.25rem 0.25rem;
                      cursor: pointer;
                      width: 130px;
                      border-right: none;
                      border-radius: 5px 0 0 5px;
                    "
                  />
                </div>
                <b-button
                  size="sm"
                  @click="searchOrClear(page)"
                  class="searchBtn"
                >
                  <b-icon-search></b-icon-search>
                </b-button>
              </div>

              <div style="width: 25px">
                <DropdownFilters @handleFilterDays="handleFilterDays" />
              </div>
            </div>
          </div>
          <b-button class="BtnCounter">
            <b-icon-coin></b-icon-coin>
            <span> NFC-e Emitidas -</span>
            <span> {{ maskCurrency(this.totalNfce) }} </span>
          </b-button>
        </div>
      </div>
      <div class="generalContainer">
        <div class="rowProvisionService">
          <div class="ContentTable" v-if="tableActive.nfce">
            <div class="headerTable">
              <div class="celTable" style="width: 10%">Data</div>
              <div class="celTable" style="width: 13%">Origem</div>
              <div class="celTable" style="width: 13%">Tipo</div>
              <div class="celTable" style="width: 10%">Nº</div>
              <div class="celTable" style="width: 27%">Cliente</div>
              <div class="celTable" style="width: 10%">Status</div>
              <div class="celTable" style="width: 10%">Valor</div>
              <div class="celTableActions">Ações</div>
            </div>
            <div
              v-for="dataSearchNota in dataNota"
              :key="dataSearchNota.id"
              :class="`rowSupplier`"
              @click.stop="editNfe(dataSearchNota.id)"
            >
              <div class="celTable" style="width: 10%">
                {{ dataSearchNota.data | moment }}
              </div>
              <div
                class="celTable"
                style="width: 13%"
                v-if="dataSearchNota.numVenda"
              >
                Venda N°{{ dataSearchNota.numVenda }}
              </div>
              <div class="celTable" style="width: 13%" v-else>--</div>
              <div class="celTable" style="width: 13%">
                {{ formatSaleType(dataSearchNota.typeSale) }}
              </div>
              <div
                class="celTable"
                style="width: 10%"
                v-if="dataSearchNota.response"
              >
                {{ dataSearchNota.response.nfe || "______" }}
              </div>
              <div class="celTable" style="width: 10%" v-else>--</div>
              <div
                class="celTable"
                style="width: 27%; font-weight: 600; text-transform: uppercase"
              >
                {{ dataSearchNota.nomeCliente || "______" }}
              </div>
              <div
                class="celTable"
                style="
                  color: #3e66ae;
                  width: 9%;
                  background-color: #ddebff;
                  border-radius: 8px;
                "
                v-if="dataSearchNota.status === 'Emitida'"
              >
                {{ dataSearchNota.status }}
              </div>
              <div
                class="celTable"
                style="
                  color: #ff5454;
                  width: 9%;
                  background-color: #ffcfc9;
                  border-radius: 8px;
                "
                v-else-if="dataSearchNota.status === 'Cancelada'"
              >
                {{ dataSearchNota.status }}
              </div>
              <div
                v-else
                class="celTable"
                style="
                  color: #4a4a4a;
                  width: 9%;
                  background-color: #d4d4d4;
                  border-radius: 8px;
                "
              >
                {{ dataSearchNota.status }}
              </div>

              <div class="celTable" style="width: 10%">
                {{
                  maskCurrency(
                    dataSearchNota.total - dataSearchNota.desconto || 0
                  )
                }}
              </div>

              <div class="celTableActions">
                <div class="btnActions">
                  <b-dropdown
                    id="dropdown-1"
                    text="Ações"
                    menu-class="w-1"
                    class="btnActions"
                    size="sm"
                    variant="none"
                  >
                    <template #button-content>
                      <b-icon-gear-fill
                        class="contentActions"
                      ></b-icon-gear-fill>
                    </template>
                    <b-dropdown-item
                      v-if="dataSearchNota.status === 'Não Enviada'"
                      @click.stop="atributeIdSale(dataSearchNota.id)"
                    >
                      Emitir NFC-e
                    </b-dropdown-item>
                    <b-dropdown-item
                      v-b-modal.modal-center3
                      @click.stop="getIdDocumentoToDelete(dataSearchNota.id)"
                    >
                      Excluir
                    </b-dropdown-item>

                    <b-dropdown-item
                      v-if="dataSearchNota.status === 'Corrigida'"
                      @click.stop="
                        openPdf(dataSearchNota.response_carta_correcao.dacce)
                      "
                    >
                      Imprimir Correção
                    </b-dropdown-item>

                    <b-dropdown-item
                      @click.stop="findDetails(dataSearchNota.id)"
                      v-b-modal.modal-center2
                      v-if="dataSearchNota.status !== 'Não Enviada'"
                    >
                      Detalhes
                    </b-dropdown-item>

                    <b-dropdown-item
                      @click.stop="duplicate(dataSearchNota.id)"
                      v-if="
                        !dataSearchNota.idVenda || !dataSearchNota.idVendaMtq
                      "
                    >
                      Duplicar
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ContainerNotes" v-if="selectedTabLabel === 'nfse'">
      <div class="headerGeneralSales">
        <div
          style="
            display: flex;
            width: 100%;
            justify-content: space-between;
            align-items: center;
            background: white;
            border-radius: 5px;
          "
        >
          <b-button class="BtnRegister">
            <b-icon-plus
              scale="1.5"
              @click.stop="handleModals('nfse')"
              style="
                width: 30px;
                background: #006458;
                height: 30px;
                color: white;
                border-radius: 3px;
              "
            ></b-icon-plus>
            <span style="width: calc(100% - 30px)">Nova NFS-e</span>
          </b-button>
          <div class="searchContainer">
            <div class="searchInput">
              <b-form-select
                class="searchFilter"
                size="sm"
                value-field="value"
                text-field="text"
                v-model="type"
                :options="filterCombobox"
              ></b-form-select>
              <div>
                <b-input
                  class="inputSearch"
                  placeholder="Pesquisar por..."
                  v-model="textPesquisa"
                  @keyup.enter="searchOrClear(page)"
                ></b-input>
              </div>
            </div>
            <div class="lineSearch">
              <div class="summaryMonth">
                Resumo: &nbsp;
                <strong>{{
                  selectTextDate === "Personalizado"
                    ? ""
                    : `(${selectTextDate})`
                }}</strong>
              </div>
              <div class="pagMonth"></div>
              <div
                class="searchInput"
                style="
                  padding: 0px !important;
                  display: flex;
                  justify-content: space-between;
                "
                v-if="selectTextDate === 'Personalizado'"
              >
                <button class="btnPeriod" size="sm">Período</button>
                <div class="dateInput">
                  <input
                    type="date"
                    id="date"
                    v-model="startDate"
                    style="
                      padding: 0.25rem 0.25rem 0.25rem 0.5rem;
                      cursor: pointer;
                      border-left: none;
                      width: 130px;
                      border-radius: 0px 5px 5px 0px;
                    "
                  />
                  <input
                    type="date"
                    id="date"
                    v-model="endDate"
                    style="
                      padding: 0.25rem 0.25rem 0.25rem 0.25rem;
                      cursor: pointer;
                      width: 130px;
                      border-right: none;
                      border-radius: 5px 0 0 5px;
                    "
                  />
                </div>
                <b-button
                  size="sm"
                  @click="filterPerMonth(page)"
                  class="searchBtn"
                >
                  <b-icon-search></b-icon-search>
                </b-button>
              </div>

              <div style="width: 25px">
                <DropdownFilters @handleFilterDays="handleFilterDays" />
              </div>
            </div>
          </div>
          <b-button class="BtnCounter">
            <b-icon-coin></b-icon-coin>
            <span>NFS-e Emitidas -</span>
            <span>
              {{
                this.TotalInvoiced.toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })
              }}
            </span>
          </b-button>
        </div>
      </div>
    </div>
    <div class="ContainerNotes" v-if="selectedTabLabel === 'mdfe'">
      <div class="headerGeneralSales">
        <div
          style="
            display: flex;
            width: 100%;
            justify-content: space-between;
            align-items: center;
            background: white;
            border-radius: 5px;
          "
        >
          <b-button class="BtnRegister">
            <b-icon-plus
              scale="1.5"
              @click.stop="handleModals('mdfe')"
              style="
                width: 30px;
                background: #006458;
                height: 30px;
                color: white;
                border-radius: 3px;
              "
            ></b-icon-plus>
            <span style="width: calc(100% - 30px)">Nova MDF-e</span>
          </b-button>
          <div class="searchContainer">
            <div class="searchInput">
              <b-form-select
                class="searchFilter"
                size="sm"
                value-field="value"
                text-field="text"
                v-model="type"
                :options="filterCombobox"
              ></b-form-select>
              <div>
                <b-input
                  class="inputSearch"
                  placeholder="Pesquisar por..."
                  v-model="textPesquisa"
                  @keyup.enter="searchOrClear(page)"
                ></b-input>
              </div>
            </div>
            <div class="lineSearch">
              <div class="summaryMonth">
                Resumo: &nbsp;
                <strong>{{
                  selectTextDate === "Personalizado"
                    ? ""
                    : `(${selectTextDate})`
                }}</strong>
              </div>
              <div class="pagMonth"></div>
              <div
                class="searchInput"
                style="
                  padding: 0px !important;
                  display: flex;
                  justify-content: space-between;
                "
                v-if="selectTextDate === 'Personalizado'"
              >
                <button class="btnPeriod" size="sm">Período</button>
                <div class="dateInput">
                  <input
                    type="date"
                    id="date"
                    v-model="startDate"
                    style="
                      padding: 0.25rem 0.25rem 0.25rem 0.5rem;
                      cursor: pointer;
                      border-left: none;
                      width: 130px;
                      border-radius: 0px 5px 5px 0px;
                    "
                  />
                  <input
                    type="date"
                    id="date"
                    v-model="endDate"
                    style="
                      padding: 0.25rem 0.25rem 0.25rem 0.25rem;
                      cursor: pointer;
                      width: 130px;
                      border-right: none;
                      border-radius: 5px 0 0 5px;
                    "
                  />
                </div>
                <b-button
                  size="sm"
                  @click="filterPerMonthMdfe(page)"
                  class="searchBtn"
                >
                  <b-icon-search></b-icon-search>
                </b-button>
              </div>

              <div style="width: 25px">
                <DropdownFilters @handleFilterDays="handleFilterDays" />
              </div>
            </div>
          </div>
          <b-button class="BtnCounter">
            <b-icon-coin></b-icon-coin>
            <span>MDF-e Emitidas -</span>
            <span>
              {{
                this.totalMdfe.toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })
              }}
            </span>
          </b-button>
        </div>
      </div>
    </div>

    <ProvisionServiceTable
      v-if="tableActive.nfse"
      :page="page"
      :dataFilterNfse="dataFilterNfse"
      @openToEdit="handleModals($event)"
      @tableLength="dataLengthNfse = $event"
    />

    <MdfeTable
      v-if="tableActive.mdfe"
      :page="page"
      :dataFilterMdfe="dataFilterMdfe"
      @openToEdit="handleModals($event)"
      @tableLength="dataLengthMdfe = $event"
      @refresh="filterPerMonthMdfe"
    />
    <!-- <div class="rowProvisionService" v-if="spinGeneral">
      <div class="loadingLazy">
        <div class="loader">
          <span>WINFIT</span>
          <span>WINFIT</span>
        </div>
        <span style="">Buscando Informações...</span>
      </div>
    </div> -->
    <b-modal
      id="modal-center2"
      hide-footer
      hide-header
      centered
      size="lg"
      title="Detalhes"
      @hidden="clearValuesToCancelDocument"
    >
      <div style="position: relative">
        <h6 class="titleModal">Detalhes da movimentação</h6>

        <span class="closeModalDetails" @click="$bvModal.hide('modal-center2')"
          >X</span
        >
        <div class="contentModal">
          <span> <b-icon-truck></b-icon-truck> Dados Cliente</span>
          <div class="rowModal">
            <div class="input-group-supplier">
              <input disabled class="input borderInput" v-model="client.nome" />
              <label class="user-label"> Nome </label>
            </div>
            <div class="input-group-supplier">
              <input
                disabled
                class="input borderInput"
                v-model="client.cpfCnpj"
              />
              <label class="user-label"> CNPJ/CPF </label>
            </div>
          </div>
        </div>
        <div class="contentModal">
          <span> <b-icon-file-text></b-icon-file-text> Dados da NF-e</span>
          <div class="rowModal">
            <div class="input-group">
              <input
                disabled
                type="datetime"
                class="input borderInput"
                v-model="dataDetails.data_nfe"
              />
              <label class="user-label"> Data da Emissão </label>
            </div>
            <div v-if="dataDetails.response" class="input-group">
              <input
                disabled
                class="input borderInput"
                v-model="dataDetails.response.nfe"
              />
              <label class="user-label"> N° NF-e </label>
            </div>
            <div v-if="dataDetails.response" class="input-group">
              <input
                disabled
                class="input borderInput"
                v-model="dataDetails.response.modelo"
              />
              <label class="user-label"> Modelo </label>
            </div>
            <div v-if="dataDetails.response" class="input-group">
              <input
                disabled
                class="input borderInput"
                v-model="dataDetails.response.serie"
              />
              <label class="user-label"> Série </label>
            </div>
          </div>
          <div v-if="dataDetails.response" class="rowModal">
            <div class="input-group-key">
              <b-form-input
                ref="chaveNfeInput"
                disabled
                class="input borderInput"
                v-model="dataDetails.response.chave"
              />
              <label class="user-label"> Chave da NF-e </label>
            </div>
            <button
              class="iconCopy"
              @click="copyChaveNfeToClipboard"
              style="border: none"
            >
              <b-icon-stickies scale="1" class="mr-1"></b-icon-stickies>
              Copiar
            </button>
          </div>

          <div class="rowModal">
            <button
              @click="redirectSefaz"
              class="btnContent-details-action-nfe"
            >
              Ir para a Sefaz
            </button>
          </div>
        </div>
        <div class="contentModal">
          <span> <b-icon-box-seam></b-icon-box-seam> Itens Importados </span>
          <div class="ContentTableModal">
            <table style="width: 100%">
              <thead
                style="
                  color: whitesmoke;
                  background: #3a4750;
                  text-align: center;
                  height: 29px;
                "
              >
                <tr style="width: 100%">
                  <th>Nome</th>
                  <th>Quantidade</th>
                  <th>Valor</th>
                  <th>Valor Total</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="product in itensNote"
                  style="text-align: center; height: 28px"
                  :key="product.id"
                >
                  <td>{{ product.nome }}</td>
                  <td>{{ product.quantidade }}</td>
                  <td>
                    {{
                      product.subtotal.toLocaleString("pt-br", {
                        style: "currency",
                        currency: "BRL",
                      })
                    }}
                  </td>
                  <td>
                    {{
                      (product.quantidade * product.subtotal).toLocaleString(
                        "pt-br",
                        {
                          style: "currency",
                          currency: "BRL",
                        }
                      )
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="btnModal-action-nfe">
          <button
            v-if="dataDetails.response"
            @click="handlePrints(dataDetails.id, dataDetails.modelo)"
            class="btnContent-details-action-nfe"
            :disabled="isLoadingToPrint"
          >
            Abrir PDF

            <b-spinner v-if="isLoadingToPrint" class="spinnerPrint" />
          </button>
          <button
            v-if="dataDetails.response"
            @click="downloadXml(dataDetails.id, dataDetails.response)"
            class="btnContent-details-action-nfe"
            :disabled="isLoadingToPrint"
          >
            Download XML

            <b-spinner v-if="isLoadingToPrint" class="spinnerPrint" />
          </button>
          <!-- <button
            v-if="dataDetails.response"
            @click="openTick(dataDetails.response.danfe_etiqueta)"
            class="btnContent-details-action-nfe"
          >
            Imprimir Etiqueta
          </button> -->
          <button
            v-if="
              dataDetails.status === 'Emitida' ||
              dataDetails.status === 'Corrigida' ||
              dataDetails.status === 'Devolvida'
            "
            class="btn-cancel-document"
            @click="openModalCancelDocument"
          >
            Cancelar Documento
          </button>
          <button
            v-if="
              dataDetails.status !== 'Não Enviada' &&
              dataDetails.status !== 'Cancelada' &&
              dataDetails.modelo === '1'
            "
            class="btn-correction-letter-document"
            @click="openModalCorrectionLetter"
          >
            Carta de correção
          </button>
        </div>
      </div>
    </b-modal>
    <div class="setBtn">
      <button class="itemBtn" :disabled="page == 1" @click="previousPage(page)">
        <b-icon-chevron-left></b-icon-chevron-left>
      </button>
      <button class="centerItemBtn">{{ page }}</button>
      <button
        class="itemBtn"
        :disabled="dataLengthNote < 9"
        @click="nextPage(page)"
      >
        <b-icon-chevron-right></b-icon-chevron-right>
      </button>
    </div>

    <div :class="sizeModal">
      <div :class="modalContainerGeneral" v-if="colapseFiscal">
        <b-button class="closeModal" @click="modalHeight"> X </b-button>
        <NotaFiscal
          class="sizeFiscal"
          v-if="typeFiscal.nfe"
          :dataNFeAfterTransformSaleToNfe="dataNFeAfterTransformSaleToNfe"
        />
        <Nfce
          class="sizeFiscal"
          v-if="typeFiscal.nfce"
          style="margin-top: 30px"
        />
        <ProvisionService
          :model="nfseModel.NFSE"
          v-if="typeFiscal.nfse"
          style="margin-top: 30px"
        />
        <Mdfe
          class="sizeFiscal"
          v-if="typeFiscal.mdfe"
          style="margin-top: 30px"
        />
      </div>
    </div>
    <Loading v-if="spinLoading" />
    <ModalCancelNota
      :modalId="cancelDocumentModalId"
      :documentType="cancelDocumentType"
      :idNota="{
        uuidNotaWebMania,
        idNota,
      }"
      @getNotaAfterCanceled="handleDocumentAfterModifyNota"
    />
    <ModalCorrectionLetter
      :idNota="idNota"
      @getNotaAfterCanceled="handleDocumentAfterModifyNota"
    />

    <ModalConfirm
      modalName="confirmDelete"
      title="Excluir Documento Fiscal"
      subtitle="Esta ação não pode ser desfeita. Deseja continuar ?"
      :rightButtonClick="deleteNfeNfce"
    />
  </div>
</template>
<script>
import moment from "moment";
import { DateTime } from "luxon";

import { mapMutations, mapState } from "vuex";
import NotaFiscal from "../NotaFiscal/NotaFiscal.vue";
import ProvisionServiceTable from "./ProvisionServiceTable.vue";
import MdfeTable from "./MdfeTable.vue";
import ProvisionService from "../ProvisionService/ProvisionService.vue";
import Mdfe from "../Mdfe/Mdfe.vue";
import Nfce from "../NotaFiscal/Nfce.vue";
import Loading from "../Loading/Loading.vue";
import ModalCancelNota from "../../components/NotaFiscal/ModalCancelNota.vue";
import ModalCorrectionLetter from "../../components/NotaFiscal/ModalCorrectionLetter.vue";
import ModalConfirm from "../../components/Modals/ModalConfirm.vue";

import mixinSearchNotaFiscal from "../../mixins/NotaFiscal/Search";
import ServiceCustomer from "../../services/serviceCustomer";
import ServiceNotaFiscal from "../../services/serviceNotaFiscal";
import ServiceNotaItem from "../../services/serviceNotaItem";
import ServiceBill from "../../services/serviceBill";
import serviceNotaFiscal from "../../services/serviceNotaFiscal";

import api from "../../services/axios";

import { BillColumnsToSearchById } from "../../utils/enums/BillColumnsToSearchById";
import { NfseModel } from "../../utils/enums/NfseModel";
import { HandleErrors } from "../../utils/handleErrors";
import { TypeErrors } from "../../utils/enums/TypeErrors";
import { maskCurrency } from "../../utils/maskMoney";
import toastAlertErros from "../../utils/toastAlertErros";
import DropdownFilters from "../../components/UI/DropdownFilters/DropdownFilters.vue";

export default {
  mixins: [mixinSearchNotaFiscal],
  components: {
    NotaFiscal,
    ProvisionService,
    Nfce,
    Mdfe,
    ProvisionServiceTable,
    MdfeTable,
    Loading,
    ModalCancelNota,
    ModalCorrectionLetter,
    ModalConfirm,
    DropdownFilters,
  },
  props: {
    initialMonth: {
      type: Date,
      default: () => new Date(),
    },
  },
  data() {
    return {
      selectTextDate: "Este mês",
      maskCurrency: maskCurrency,
      year: DateTime.local().year,
      month: DateTime.local(),
      dataNFeAfterTransformSaleToNfe: {},
      textPesquisa: "",
      type: "",
      startDate: "",
      endDate: "",
      spinLoading: false,
      spinGeneral: false,
      totalNfe: 0,
      totalNfce: 0,
      TotalInvoiced: 0,
      totalMdfe: 0,
      dataDetails: [],
      dataFilterNfse: [],
      dataFilterMdfe: [],
      uuidNotaWebMania: "",
      idNota: "",
      client: [],
      itensNote: [],
      page: 1,
      dataLengthNote: 0,
      dataLengthNfse: 0,
      dataLengthMdfe: 0,
      dataNota: [],
      model: 1,
      filterCombobox: [
        { value: "nomeCliente", text: "Cliente" },
        { value: "numero", text: "Nº Operação" },
        { value: "status", text: "Status" },
        { value: "", text: "Selecione ..." },
      ],
      filterSituationCombobox: [
        { value: "Cancelada", text: "Cancelada" },
        { value: "Emitida", text: "Emitida" },
        { value: "Devolvida", text: "Devolvida" },
        { value: "Não Enviada", text: "Não Enviada" },
        { value: "Contingência", text: "Contingência" },
        { value: "Processamento", text: "Processamento" },
        { value: "Corrigida", text: "Corrigida" },
        { value: "", text: " Clique para selecionar a situação " },
      ],
      tableActive: {
        nfe: true,
        nfce: false,
        nfse: false,
      },
      responseNfeWebMania: {
        chave: "",
        danfe: "",
        danfe_etiqueta: "",
        danfe_simples: "",
        log: "",
        modelo: "",
        motivo: "",
        nfe: "",
        serie: "",
        status: "",
        uuid: "",
        xml: "",
      },
      nfseModel: NfseModel,
      idDocumentoToDelete: null,
      isLoadingToPrint: false,
      selectedTabLabel: "nfe",
      tabs: [
        { value: "nfe", text: "NF-e" },
        { value: "nfce", text: "NFC-e" },
        { value: "nfse", text: "NFS-e" },
        { value: "mdfe", text: "MDF-e" },
      ],
    };
  },
  methods: {
    ...mapMutations([
      "ALTER_SIZE_MODAL",
      "ALTER_TYPE_FISCAL",
      "SET_DATA_NFE",
      "SET_DEFAULT_TYPE_FISCAL",
      "SET_COLAPSE_FISCAL",
      "ALTER_MODAL_CONTAINER_GENERAL",
      "SET_DATA_SEARCH_FROM_BOX_FRONT",
    ]),
    formatSaleType(typeSale) {
      const saleTypeLabels = {
        "Receita Pedido": "Venda Completa",
        Pedido: "Venda Simples",
      };

      return saleTypeLabels[typeSale] || typeSale || "--";
    },
    storeLabelTabName(labelName) {
      this.selectedTabLabel = labelName;
      this.handleActiveTable(labelName);
    },
    async modalHeight() {
      this.SET_COLAPSE_FISCAL(!this.colapseFiscal);

      this.colapseFiscal
        ? this.ALTER_SIZE_MODAL("ModalGeneral")
        : this.ALTER_SIZE_MODAL("disable");

      this.modalContainerGeneral
        ? this.ALTER_MODAL_CONTAINER_GENERAL("modalContainer")
        : this.ALTER_MODAL_CONTAINER_GENERAL("contentModalDisable");

      if (!this.colapseFiscal) {
        this.dataNFeAfterTransformSaleToNfe = {};
        this.SET_DEFAULT_TYPE_FISCAL();
        this.SET_DATA_NFE({});
      }

      await this.filterPerMonth();
      await this.filterNota();
      await this.filterPerMonthMdfe();

      if (this.tableActive.nfce || this.tableActive.nfe) {
        this.filterNota(1);
      }
    },

    async handleFilterDays(valueDate, textValueDate) {
      this.clearSearch();
      this.selectTextDate = textValueDate;

      const today = DateTime.local();

      switch (valueDate) {
        case "hoje":
          this.startDate = today.toSQLDate();
          this.endDate = today.toSQLDate();
          break;
        case "esteMes":
          this.startDate = today.startOf("month").toSQLDate();
          this.endDate = today.endOf("month").toSQLDate();
          break;
        case "ontem":
          // eslint-disable-next-line no-case-declarations
          const yesterday = today.minus({ days: 1 });
          this.startDate = yesterday.toSQLDate();
          this.endDate = yesterday.toSQLDate();
          break;
        case "7dias":
          this.startDate = today.minus({ days: 7 }).toSQLDate();
          this.endDate = today.toSQLDate();
          break;
        case "30dias":
          this.startDate = today.minus({ days: 30 }).toSQLDate();
          this.endDate = today.toSQLDate();
          break;
        case "mesPassado":
          // eslint-disable-next-line no-case-declarations
          const lastMonth = today.minus({ months: 1 });
          this.startDate = lastMonth.startOf("month").toSQLDate();
          this.endDate = lastMonth.endOf("month").toSQLDate();
          break;
        case "ultimos3meses":
          this.startDate = today
            .minus({ months: 3 })
            .startOf("month")
            .toSQLDate();
          this.endDate = today.toSQLDate();
          break;
        default:
          break;
      }
      if (this.tableActive.nfse) {
        await this.filterPerMonth();
      } else if (this.tableActive.mdfe) {
        await this.filterPerMonthMdfe();
      } else {
        await this.filterNota();
      }
    },
    async filterNota() {
      if (this.tableActive.nfce) {
        this.model = "2";
      } else {
        this.model = "1";
      }
      try {
        this.spinGeneral = true;
        const { data } = await api.get(
          `/nota/find/all/notes/by/table/per/month/search?q=${encodeURIComponent(
            this.textPesquisa
          )}&type=${this.type}&model=${this.model}&page=${
            this.page
          }&startDate=${this.startDate}&endDate=${this.endDate}`
        );

        this.dataLengthNote = data.data.notes.length;
        this.dataNota = data.data.notes;
        this.totalNfe = data.data.totals.totalNfe;
        this.totalNfce = data.data.totals.totalNfce;
      } catch (error) {
        this.$toast.open({
          message: "Não foi possível listar as notas",
          type: "info",
        });
      } finally {
        this.spinGeneral = false;
      }
    },

    async filterPerMonth() {
      try {
        const { data } = await api.get(
          `/nfse/per/month/search?month=${this.month.month}&year=${
            this.year
          }&model=${NfseModel.NFSE}&q=${encodeURIComponent(
            this.textPesquisa
          )}&type=${this.type}&page=${this.page}&isAdvancedSearch=${
            this.isAdvancedSearch
          }&startDate=${this.startDate}&endDate=${this.endDate}`
        );
        this.dataLengthNfse = data.data.length;
        this.dataFilterNfse = data.data;
        this.TotalInvoiced = this.getTotalInvoiced(this.dataFilterNfse);
      } catch (error) {
        console.log(error);
      }
    },

    async filterPerMonthMdfe() {
      try {
        const { data } = await api.get(
          `/mdfe/find/per/month?q=${encodeURIComponent(
            this.textPesquisa
          )}&type=${this.type}&page=${this.page}&startDate=${
            this.startDate
          }&endDate=${this.endDate}`
        );
        this.dataLengthMdfe = data?.data?.length || 0;
        this.dataFilterMdfe = data?.data?.mdfes || [];
        this.totalMdfe = data?.data?.totalMdfes || 0;
      } catch (error) {
        console.log(error);
      }
    },

    getTotalMdfeByType(mdfes) {
      let dataArray = [];
      if (Array.isArray(mdfes)) {
        dataArray = mdfes;
      } else if (mdfes && typeof mdfes === "object") {
        dataArray = Object.values(mdfes);
      }
      return dataArray
        .filter((mdfe) => mdfe.status === "aprovado")
        .reduce((total, mdfe) => total + mdfe.valor_carga, 0);
    },
    getTotalInvoiced(orders) {
      return orders.reduce(
        (total, order) => total + (order.valorFaturado || 0),
        0
      );
    },
    openModalCancelDocument() {
      this.uuidNotaWebMania = this.dataDetails.response.uuid;
      this.idNota = this.dataDetails.id;

      this.$bvModal.show(this.cancelDocumentModalId);
    },

    openModalCorrectionLetter() {
      this.idNota = this.dataDetails.id;

      this.$bvModal.show("modalCorrectionLetter");
    },

    clearValuesToCancelDocument() {
      this.uuidNotaWebMania = "";
      this.idNota = "";
    },

    async handleDocumentAfterModifyNota() {
      await this.findDetails(this.dataDetails.id);
      await this.filterNota(1);
      this.page = 1;
    },

    copyChaveNfeToClipboard() {
      const inputElement = this.$refs.chaveNfeInput;
      try {
        navigator.clipboard.writeText(inputElement.value);
        this.$toast.open({
          message: "Chave da NF-e copiada para a área de transferência.",
          type: "success",
        });
      } catch (err) {
        this.$toast.open({
          message: "Não foi possível copiar a chave da NF-e.",
          type: "info",
        });
      }
    },

    handleModals(name) {
      this.ALTER_TYPE_FISCAL(name);
      this.modalHeight();
    },

    handleActiveTable(name) {
      this.page = 1;

      this.tableActive = {
        nfe: false,
        nfce: false,
        nfse: false,
        mdfe: false,
        [name]: true,
      };

      if (name === "mdfe") {
        this.filterPerMonthMdfe();
      } else if (name === "nfse") {
        this.filterPerMonth();
      } else {
        this.filterNota();
      }
    },

    handleDataNFeAfterTransformSaleToNfe() {
      this.dataNFeAfterTransformSaleToNfe = this.dataNFe;
      this.handleModals("nfe");
      this.SET_DATA_NFE({});
    },

    async editNfe(id) {
      try {
        const result = await ServiceNotaFiscal.findNotaById(id);
        const products = await ServiceNotaItem.findByIdNota(id);
        const bills = await ServiceBill.getAllBillsByParamsId(
          id,
          BillColumnsToSearchById.idNota
        );
        result.products = products.noteItem;
        result.bills = bills;

        if (result.modelo === "1") {
          this.ALTER_TYPE_FISCAL("nfe");
          this.modalHeight();
          this.SET_DATA_NFE(result);
        } else {
          this.ALTER_TYPE_FISCAL("nfce");
          this.modalHeight();
          this.SET_DATA_NFE(result);
        }
      } catch (error) {
        const message = error?.response?.data?.message;
        const typeError = HandleErrors(message);

        if (message && message.includes("NOT_ALLOWED"))
          return this.$toast.open({
            message: message.split(":")[1],
            type: "info",
          });
        else if (typeError && Object.keys(typeError).length) {
          return this.$toast.open({
            message: typeError.message,
            type: "info",
          });
        } else
          return toastAlertErros.validateErroDoesNotContainFor(
            error,
            this.$toast
          );
      }
    },

    async findDetails(id) {
      this.dataDetails = await ServiceNotaFiscal.findNotaById(id);
      const date = this.dataDetails.data_nfe
        .split(" ")[0]
        .split("-")
        .reverse()
        .join("/");
      const hours = this.dataDetails.data_nfe.split(" ")[1];

      this.dataDetails.data_nfe = `${date} ${hours}`;
      this.client = await ServiceCustomer.findById(this.dataDetails.idCliente);
      const result = await ServiceNotaItem.findByIdNota(id);
      this.itensNote = result.noteItem;
    },

    async duplicate(id) {
      try {
        await ServiceNotaFiscal.duplicate(id);

        this.page = 1;
        await this.filterNota();

        this.$toast.open({
          message: "Nota duplicada com sucesso",
        });
      } catch (error) {
        const typeError = HandleErrors(error?.response?.data?.message);

        this.$toast.open({
          message:
            typeError.message || "Ocorreu um problema ao duplicar a nota",
          type: "info",
        });
      }
    },

    searchOrClear() {
      this.filterNota();
    },

    clearSearch() {
      this.textPesquisa = "";
      this.type = "";
      const today = DateTime.local();
      this.startDate = today.startOf("month").toSQLDate();
      this.endDate = today.endOf("month").toSQLDate();
    },

    async redirectSefaz() {
      try {
        window.open(
          "https://www.nfe.fazenda.gov.br/portal/consultaRecaptcha.aspx?tipoConsulta=resumo&tipoConteudo=7PhJ+gAVw2g=",
          "_blank"
        );
      } catch (error) {
        this.$toast.open({
          message: "Ocorreu um erro ao redirecionar para a página",
          type: "info",
        });
      }
    },

    atributeIdSale(idNota) {
      this.idNota = idNota;
      this.sendCoupon(true);
    },

    async sendCoupon(isLeaveClient) {
      try {
        this.spinLoading = true;
        const data = await ServiceNotaFiscal.sendCoupon(
          null,
          isLeaveClient,
          this.idNota
        );

        this.responseNfeWebMania.danfe = data.dataWebMania.danfe;
        this.visualizarNfe(this.responseNfeWebMania.danfe);

        await this.filterNota(1);

        return this.$toast.open({
          message: "Cupom Fiscal emitido com sucesso!",
          type: "success",
        });
      } catch (error) {
        console.log(error);
        const typeError = HandleErrors(error?.response?.data?.message);

        if (typeError && typeError?.nameError === TypeErrors.NO_PERMISSIONS) {
          return this.$toast.open({
            message: typeError.message,
            type: "info",
          });
        }

        return this.$toast.open({
          message:
            error?.response?.data?.message ||
            error?.response?.data?.erros ||
            "Ops! Houve algum erro. Verifique os dados e tente novamente",
          type: "info",
        });
      } finally {
        this.spinLoading = false;
      }
    },

    visualizarNfe(danfe) {
      window.open(danfe, "_blank", "width=700, height=800, top=500, left=500");
    },

    async openPdf(pdf) {
      try {
        window.open(`${pdf}`, "_blank");
      } catch (error) {
        this.$toast.open({
          message: "Ocorreu um erro ao abrir o arquivo",
          type: "info",
        });
      }
    },

    async printNf(id) {
      try {
        this.isLoadingToPrint = true;
        const pdfUrl = await serviceNotaFiscal.printNf(id);

        window.open(pdfUrl, "_blank");
      } catch (error) {
        this.$toast.open({
          message: "Ocorreu um erro ao abrir o arquivo",
          type: "info",
        });
      } finally {
        this.isLoadingToPrint = false;
      }
    },

    async printNfce(id) {
      try {
        this.isLoadingToPrint = true;
        const danfe = await ServiceNotaFiscal.printNfce(id);

        const win = window.open(
          danfe,
          "_blank",
          "width=700, height=800, top=500, left=500"
        );

        win.document.write(danfe);

        win.document.close();
      } catch (error) {
        console.log(error);
        this.$toast.open({
          message: "Ocorreu um erro ao abrir o arquivo",
          type: "info",
        });
      } finally {
        this.isLoadingToPrint = false;
      }
    },

    handlePrints(id, typeDocument) {
      if (typeDocument === "2") {
        return this.printNfce(id);
      }

      this.printNf(id);
    },

    async downloadXml(idNota, response) {
      if ((!response || !response.xml, !idNota)) {
        return;
      }

      try {
        await ServiceNotaFiscal.downloadSingleXml(idNota);

        this.$toast.open({
          type: "success",
          message: "Download realizado com sucesso!",
        });
      } catch (error) {
        this.$toast.open({
          type: "info",
          message: "Ocorreu um problema ao realizar o download do xml!",
        });
      }
    },

    async openTick(etiqueta) {
      try {
        window.open(`${etiqueta}`, "_blank");
      } catch (error) {
        this.$toast.open({
          message: "Ocorreu um erro ao abrir o arquivo",
          type: "info",
        });
      }
    },

    async deleteNfeNfce() {
      try {
        await ServiceNotaItem.deleteNotaAndItem(this.idDocumentoToDelete);

        this.idDocumentoToDelete = null;
        this.$bvModal.hide("modal-center3");
        this.filterNota(1);
      } catch (error) {
        const message = error?.response?.data?.message;
        const typeError = HandleErrors(message);

        if (message && message.includes("NOT_ALLOWED"))
          this.$toast.open({
            message: message.split(":")[1],
            type: "info",
          });
        else if (typeError && Object.keys(typeError).length) {
          this.$toast.open({
            message: typeError.message,
            type: "info",
          });
        } else
          toastAlertErros.validateErroDoesNotContainFor(error, this.$toast);

        this.$bvModal.hide("modal-center3");

        return;
      } finally {
        this.idDocumentoToDelete = null;
      }
    },

    getIdDocumentoToDelete(idDocument) {
      this.idDocumentoToDelete = idDocument;
      this.$bvModal.show("confirmDelete");
    },

    nextPage() {
      this.tableActive.nfse
        ? this.filterPerMonth((this.page += 1))
        : this.filterNota((this.page += 1));
    },

    previousPage() {
      if (this.page === 1) {
        return;
      } else {
        this.tableActive.nfse
          ? this.filterPerMonth((this.page -= 1))
          : this.filterNota((this.page -= 1));
      }
    },
  },
  computed: {
    ...mapState([
      "sizeModal",
      "typeFiscal",
      "dataNFe",
      "colapseFiscal",
      "modalContainerGeneral",
      "dataConfig",
      "dataPlan",
    ]),
    cancelDocumentType() {
      return String(this.dataDetails.modelo) === "2" ? "nfce" : "nfe";
    },
    cancelDocumentModalId() {
      return this.cancelDocumentType === "nfce"
        ? "modalCancelNfce"
        : "modalCancelNota";
    },
  },
  filters: {
    moment: function (date) {
      return moment(date).format("DD/MM/YYYY");
    },
  },
  async created() {
    const today = DateTime.local();
    this.startDate = today.startOf("month").toSQLDate();
    this.endDate = today.endOf("month").toSQLDate();
    this.handleActiveTable("nfe");
  },
  mounted() {
    if (Object.keys(this.dataNFe).length && this.dataNFe.nfe.idVenda) {
      this.handleDataNFeAfterTransformSaleToNfe();
    }
  },
  beforeDestroy() {
    this.ALTER_SIZE_MODAL("disable");
    this.SET_COLAPSE_FISCAL(false);
    this.ALTER_MODAL_CONTAINER_GENERAL("contentModalDisable");
    this.SET_DEFAULT_TYPE_FISCAL();
    this.SET_DATA_NFE({});
  },
};
</script>
<style scoped>
.GeneralFiscal {
  display: flex;
  flex-direction: column;
  margin-left: 80px;
  width: calc(100% - 100px);
  height: 100vh;
  font-size: 12px;
}

.ContainerBtnFiscal {
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 95px;
  margin-top: 65px;
  width: 100%;
}

.ContainerBtnFiscalRestrict {
  display: flex;
  justify-content: flex-start;
  gap: 20px;
  align-items: center;
  height: 95px;
  margin-top: 65px;
  width: 100%;
}

.BtnFiscal {
  width: 23%;
  border: none;
  height: 35px;
  border-radius: 3px;
  font-size: 12px;
  box-shadow: 0px 12px 4px -10px rgba(142, 142, 142, 0.78);
}

.SummaryFiscal {
  display: flex;
  height: 90px;
  width: 100%;
  justify-content: space-around;
  align-items: center;
  border-bottom: 1px solid rgb(199, 198, 198);
  padding: 0px 0px 5px 0px;
}

.SummaryFiscalRestrict {
  display: flex;
  height: 90px;
  width: 100%;
  justify-content: flex-start;
  gap: 20px;
  align-items: center;
  border-bottom: 1px solid rgb(199, 198, 198);
  padding: 0px 0px 5px 0px;
}

.ItemSummaryFiscal {
  width: 23%;
  height: 70px;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  box-shadow: 0px 12px 4px -10px rgba(142, 142, 142, 0.78);
  cursor: pointer;
}

.searchFilter {
  width: 110px;
  border-right: none;
  height: 30px;
  font-size: 11px;
  text-align: center;
}

.searchFilter:focus {
  box-shadow: none;
  border: 1px solid #e3e0e0;
}
.carroselCtn {
  display: flex;
  align-items: flex-end;
  gap: 10px;
  margin-top: 61px;
  width: 100%;
  background: #ffffff;
  border-radius: 3px;
}

.StatementOnAccount {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 5px;
}

.StatementOnAccount ::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}
.StatementOnAccount::-webkit-scrollbar-track {
  background: white;
}

.StatementOnAccount::-webkit-scrollbar-thumb {
  background-color: transparent;
  border-radius: 2px;
}

.StatementOnAccountItem {
  margin: 0px !important;
  height: 30px;
  padding: 10px 30px;
  color: #006458;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  text-transform: capitalize;
  transition: background-color 0.3s ease, color 0.3s ease,
    border-bottom 0.3s ease, height 0.3s ease, padding-bottom 0.3s ease,
    transform 0.3s ease;
}

.StatementOnAccountItem p {
  font-weight: 600;
}

.StatementOnAccountItem.active {
  color: #006458;
  border-bottom: 3px solid #006458;
}

.StatementOnAccountItem:hover {
  background-color: #eaeaea;
  color: #006458;
}

.StatementOnAccountItem:focus {
  background: #006458;
  color: white;
  border-bottom: 3px solid #ff0040 !important;
  outline: none;
}
.summaryMonth {
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
  cursor: context-menu;
  padding: 0 0 0 7px;
  color: #2e2e2e;
  display: flex;
  align-items: center;
}
.custom-select {
  left: 4px;
  position: relative;
  border-right: none;
  border-radius: 5px 0px 0px 5px;
  border: 1px solid #e3e0e0;
  -moz-appearance: none;
  appearance: none;
}

.searchFilterSituation {
  width: 230px;
  border-left: none !important;
  height: 30px;
  border-radius: 0 5px 5px 0 !important;
  font-size: 11px;
  text-align: center;
  cursor: pointer;
  position: relative !important;
}

.searchFilterSituation:focus {
  box-shadow: none;
  border: 1px solid #e3e0e0;
}

.searchInput {
  display: flex;
  margin: 5px 0px 5px 0px;
}

.btnPeriod {
  border-radius: 5px 0px 0px 5px;
  border: 1px solid rgb(235 235 235);
  padding: 0 10px;
  height: 30px;
  font-size: 11px;
  cursor: context-menu;
}

.ContainerSearchInput {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  width: 100%;
  padding: 0 10px;
  max-width: 100%;
  border: 1px solid #e6e6e6;
  border-top: none;
  border-bottom: none;
}

.textRegister {
  font-weight: bold;
  padding-left: 20px;
  color: #006458;
}

.searchContainer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  border: 1px solid #e6e6e6;
  border-top: none;
  border-bottom: none;
  gap: 5px;
  padding: 0 5px;
}

.searchAvancedContent {
  display: flex;
  padding: 3px 0px 3px 0;
  align-items: center;
  justify-content: flex-end;
}

.spinnerPrint {
  color: white;
  position: absolute;
  right: 5px;
  width: 20px;
  height: 20px;
}

.form-control-sm {
  padding: 0.25rem 1.5rem;
  height: 30px;
}

.form-control {
  font-size: 13px;
}

.dateInput {
  display: flex;
  gap: 10px;
}

input {
  border: 1px solid #e3e0e0;
  border-radius: 5px;
  height: 30px;
}

.searchBtn {
  right: 0px;
  height: 30px;
  position: relative;
  background: whitesmoke;
  color: #006256;
  border-radius: 0px 5px 5px 0px;
  border-left: none;
  border-color: #e3e0e0;
}

input:focus {
  box-shadow: none;
  border: 1px solid #e3e0e0;
}

button:focus {
  box-shadow: none;
}

.actiontd {
  display: flex;
  justify-content: center;
  margin-right: 20px;
}

tr:nth-child(even) {
  background: #e2e3e4;
}

.defaultSearch {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100px;
  margin-top: 20px;
  justify-content: center;
  align-items: center;
}

.defaultSearch span {
  font-size: 1rem;
}

.loadingLazy {
  position: absolute;
  top: 20%;
  width: calc(100% - 100px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
}

/* spinner */
.loader {
  position: relative;
}

.loader span {
  position: absolute;
  color: #fff;
  transform: translate(-50%, -50%);
  font-size: 38px;
  letter-spacing: 5px;
}

.loader span:nth-child(1) {
  color: transparent;
  -webkit-text-stroke: 0.3px #006458;
}

.loader span:nth-child(2) {
  color: #006458;
  -webkit-text-stroke: 1px #006458;
  animation: loading 3s ease-in-out infinite;
}

@keyframes loading {
  0%,
  100% {
    clip-path: polygon(
      0% 30%,
      15% 54%,
      32% 50%,
      54% 60%,
      70% 61%,
      84% 69%,
      100% 32%,
      100% 100%,
      0% 100%
    );
  }

  50% {
    clip-path: polygon(
      0% 60%,
      16% 65%,
      34% 66%,
      51% 62%,
      67% 50%,
      84% 45%,
      100% 46%,
      100% 100%,
      0% 100%
    );
  }
}
.titleModal {
  font-size: 12px;
  border-bottom: 1px solid #e6e7e8;
}

.titleModal {
  font-size: 1rem;
  border-bottom: 1px solid #e6e7e8;
  font-weight: bold;
}

.btnModal {
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.btnContent {
  font-size: 11px;
  border: 1px solid #006256;
  border-radius: 3px;
  width: 45%;
  height: 28px;
  position: relative;
  color: #ffffff;
  background: #006256;
}

.btnContentReceive {
  font-size: 11px;
  border: 1px solid #006256;
  border-radius: 3px;
  width: 45%;
  height: 28px;
  position: relative;
  color: #006256;
  background: white;
}

.btnContent-action-nfe {
  font-size: 11px;
  border: 1px solid #006256;
  border-radius: 3px;
  width: 45%;
  height: 28px;
  position: relative;
  color: #ffffff;
  background: #006256;
}

.btnContent-details-action-nfe {
  font-size: 11px;
  border: 1px solid #006256;
  border-radius: 3px;
  width: 17%;
  height: 28px;
  position: relative;
  color: #ffffff;
  background: #006256;
  display: flex;
  justify-content: center;
  align-items: center;
}

.btnContentReceive-action-nfe {
  font-size: 11px;
  border: 1px solid #006256;
  border-radius: 3px;
  width: 45%;
  height: 28px;
  position: relative;
  color: #006256;
  background: white;
}

.btn-cancel-document {
  font-size: 11px;
  border: 1px solid brown;
  border-radius: 3px;
  width: 20%;
  height: 28px;
  position: relative;
  color: white;
  background: brown;
}

.btn-correction-letter-document {
  font-size: 11px;
  border: 1px solid rgb(242, 168, 62);
  border-radius: 3px;
  width: 20%;
  height: 28px;
  position: relative;
  color: white;
  background: rgb(242, 168, 62);
}

.setBtn {
  display: flex;
  flex-direction: row;
  margin: 0 1rem 1rem 0;
  gap: 10px;
  bottom: 0;
  right: 0;
  position: absolute;
}

.itemBtn {
  display: flex;
  text-align: center;
  align-content: center;
  justify-content: center;
  align-items: center;
  width: 25px;
  height: 25px;
  font-weight: bold;
  border: 1px solid rgb(175, 174, 174);
  border-radius: 50%;
  color: #3a4750;
}

.itemBtn:hover {
  background: #3a4750;
  color: whitesmoke;
}

.itemBtn:disabled {
  opacity: 0;
}

.centerItemBtn {
  display: flex;
  text-align: center;
  align-content: center;
  justify-content: center;
  align-items: center;
  width: 25px;
  height: 25px;
  font-weight: bold;
  border: 1px solid rgb(175, 174, 174);
  border-radius: 50%;
  color: #1b3159;
  cursor: auto;
}

.ModalGeneral {
  position: fixed !important;
  z-index: 900;
  top: 50px;
  left: 61px;
  height: calc(100% - 53px);
  max-height: calc(100% - 53px);
  overflow: auto;
  width: calc(100% - 62px);
  background: #ffff;
  transition: all 0.7s ease-in-out;
}

.searchAll {
  justify-content: center;
  color: #006256;
  font-size: 13px;
  padding: 5px 0.5rem;
  font-weight: bold;
  border: solid 1px #e3e0e0;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.searchAll:hover {
  background: rgb(205, 205, 205);
}

.disable {
  position: absolute;
  width: calc(100% - 62px);
  height: 0;
  left: 61px;
  top: 100vh;
  background: #b0b0b000;
  visibility: hidden;
  transition: all 0.7s ease-in-out;
}

.closeModal {
  position: fixed;
  top: 51px;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 900;
  font-size: 18px;
  height: 30px;
  background: white;
  border: none;
  color: rgb(6, 6, 6);
}

.closeModal:hover {
  background: whitesmoke;
  color: red;
}

.closeModal:focus {
  background: red;
  border: none;
  box-shadow: none;
}

.sizeFiscal {
  margin-top: 20px;
  width: 80vw;
}

.contentModalDisable {
  display: none;
  background: white;
  opacity: 0;
}

.lineSearch {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.searchByMonth {
  width: 30%;
  display: flex;
  align-items: center;
  margin: 5px 0px 8px 20px;
  border-radius: 5px;
  justify-content: space-around;
  border: 1px solid #e3e0e0;
}

.pagMonth {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.searchMonth {
  width: 100px;
  height: 30px;
  border-radius: 5px 0px 0px 5px;
  font-size: 11px;
  text-align: center;
  font-family: Poppins-Regular, sans-serif !important;
}

.searchMonth:focus {
  box-shadow: none;
  border: 1px solid rgb(195, 193, 193);
}

.searchYear {
  width: 50px;
  height: 30px;
  border-radius: 0px 5px 5px 0px;
  border: 1px solid rgb(195, 193, 193);
  font-size: 11px;
  text-align: center;
  font-family: Poppins-Regular, sans-serif !important;
}

.searchYear:focus {
  box-shadow: none;
  border: 1px solid rgb(195, 193, 193);
}

.custom-select3 {
  left: 4px;
  -moz-appearance: none;
  appearance: none;
  background: none;
  font-weight: bold;
  padding: 0 !important;
}

.modalContainer {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.btnActions {
  display: flex;
}

.dropdown-menu {
  font-size: 12px;
  min-width: 5rem !important;
  width: 5rem !important;
  padding: 0 !important;
  margin: 0.125rem 0 0;
  color: red;
  background: red;
  text-align: center;
  list-style: none;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
}

.dropdown-menu li {
  font-size: 12px;
  width: 100% !important;
  padding: 0 !important;
  margin: 0.125rem 0 0;
  display: flex;
  text-align: center;
  list-style: none;
  border: none;
}

.typeSale {
  color: #403b74;
  font-weight: bold;
}

.typeSale2 {
  color: #48b865;
  font-weight: bold;
}

.typeSale3 {
  color: #f2a83e;
  font-weight: bold;
}

.titleModal {
  font-size: 12px;
  border-bottom: 1px solid #e6e7e8;
}

.btnModal-action-nfe {
  margin-top: 10px;
  margin-bottom: 20px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.contentModal {
  border: 1px solid rgb(230, 230, 230);
  border-radius: 5px;
  display: flex;
  font-size: 13px;
  flex-direction: column;
  padding: 5px 10px 5px 10px;
  background: #f9f9f94d;
  margin-bottom: 10px;
}

.rowModal {
  display: flex;
  width: 100%;
  padding: 20px 0 5px 0;
  justify-content: space-between;
  gap: 10px;
}

.closeModalDetails {
  width: 22px;
  height: 23px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: -8px;
  top: -13px;
  color: red;
  border-radius: 5px;
  cursor: pointer;
  border: solid 1px red;
  transition: ease-in all 0.2s;
  font-size: 14px;
  background-color: rgb(239, 239, 239);
}

.closeModalDetails:hover {
  background-color: red;
  color: white;
}

.input-group-supplier {
  width: 45%;
  position: relative;
}

.input-group-key {
  width: 100%;
  position: relative;
}

.ContentTableModal {
  display: flex;
  flex-direction: column;
  padding: 10px 20px 0 20px;
  width: 100%;
}

.user-label {
  position: absolute;
  left: 15px;
  font-size: 11px;
  z-index: 30;
  bottom: 21px;
  pointer-events: none;
  transform: translateY(0.5rem);
  transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
}

.iconCopy {
  position: absolute;
  right: 10px !important;
  z-index: 10;
  background-color: #c1c1c1;
  color: rgb(0, 0, 0);
  height: 30px;
  width: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.25rem;
  cursor: pointer;
}

.input {
  font-size: 12px !important;
  width: 100%;
  padding: 0 0 0 10px;
}

.input:focus ~ label,
input:valid ~ label {
  transform: translateY(-50%) scale(0.8);
  background-color: #ffffff;
  padding: 0 0.1em;
  font-weight: 600;
}
.ContainerNotes {
  gap: 10px;
  display: flex;
  flex-direction: column;
}
.headerGeneralSales {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  background: white;
  border-radius: 5px;
  gap: 10px;
  border: 1px solid #e3e0e0;
  padding: 0 10px;
}
.headerCounter {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  background: white;
  border-radius: 5px;
  margin: 5px 0;
  border: 1px solid #e3e0e0;
  padding: 10px;
}
.BtnRegister {
  width: 250px;
  padding: 0 !important;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #e3ebe2;
  height: 30px;
  border-radius: 3px;
  font-size: 13px;
  margin-right: 5px;
  color: #006458;
  border: 1px solid #cfe5e3;
}

.BtnRegister:hover {
  background: whitesmoke;
  color: #006458;
  border: 1px solid #006458;
  box-shadow: none;
}

.BtnRegister:focus {
  background: whitesmoke;
  color: #006458;
  border: 1px solid #006458;
  box-shadow: none;
}
.BtnCounter:focus {
  background: whitesmoke;
  color: #006458;
  border: 1px solid #006458;
  box-shadow: none;
}
.BtnCounter {
  width: 300px;
  padding: 0 !important;
  margin-left: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  height: 30px;
  gap: 5px;
  border-radius: 0px;
  font-size: 13px;
  color: #000000;
  border: none;
  border-bottom: 1px solid #525858;
}
.BtnCounter:hover {
  box-shadow: none;
  background: #ffffff;
  color: #000000;
  cursor: context-menu;
}
.Summary {
  display: flex;
  flex-direction: column;
  width: 40%;
  gap: 10px;
  justify-content: flex-start;
}

.iconItem {
  display: flex;
  width: 50px;
  height: 100%;
  justify-content: center;
  align-items: center;
  color: white;
}
.iconItem:hover {
  background: #006256;
  cursor: pointer;
}

.ItemSummarySales {
  height: 60px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 500;
  box-shadow: 0px 12px 4px -10px rgba(142, 142, 142, 0.78);
  text-transform: capitalize;
  font-family: Poppins-Regular, sans-serif !important;
}

.ItemSummarySales span {
  font-size: 13px;
  cursor: context-menu;
  letter-spacing: 1px;
}
.ContentTable {
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: auto;
  gap: 1px;
  width: 100%;
  min-height: 60vh;
  max-width: 100%;
}
.headerTable {
  border-radius: 5px 5px 0 0;
  width: 100%;
  display: flex;
  align-items: center;
  height: 30px;
  background: #006256;
  color: whitesmoke;
  font-weight: bold;
}
.rowSupplier {
  width: 100%;
  display: flex;
  align-items: center;
  background: #f8f8f8;
  border: 1px solid rgb(226, 226, 226);
  border-radius: 2px;
  text-align: center;
  height: 35px;
  padding: 0;
  cursor: context-menu;
  color: #313131;
  font-size: 12px;
}

.rowSupplier:hover {
  background: rgb(242, 242, 242);
  cursor: pointer;
}

.celTable {
  display: flex;
  flex-direction: column;
  text-align: center;
}

.celTableActions {
  display: flex;
  gap: 10px;
  width: 8%;
  text-align: center;
  justify-content: center;
  align-items: center;
}

.celInfos {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #006256;
  border-radius: 5px;
  height: 25px;
  width: 30px;
  font-size: 10px !important;
  font-weight: 100 !important;
  color: white;
}
@media screen and (min-width: 768px) and (max-width: 1200px) {
  .GeneralFiscal {
    margin-left: 60px;
    width: calc(100% - 60px);
    font-size: 11px;
  }
  .ItemSummaryFiscal {
    width: 24%;
    height: 50px;
    gap: 0px;
  }
  .ContainerBtnFiscal {
    padding: 0px 0px 5px 0px;
  }
  .searchContainer {
    height: 40px;
  }
  .searchInput {
    width: auto;
    margin: 10px 0px 10px 10px;
  }
  .searchFilter {
    width: 93px;
  }
  .btnPeriod {
    width: 60px;
    font-size: 10px;
  }
  .ContentTable {
    padding: 5px 10px;
  }
  .setBtn {
    margin: 0 1rem 10px 0;
  }
  .itemBtn {
    width: 18px;
    height: 18px;
  }
  .centerItemBtn {
    width: 18px;
    height: 18px;
  }
  .FooterPagination {
    padding: 0px;
  }
}

@media screen and (max-width: 700px) {
  .GeneralFiscal {
    display: flex;
    flex-direction: column;
    margin-left: 0px;
    width: 100%;
    height: 100vh;
    font-size: 11px;
  }

  .SummaryFiscal {
    margin-top: 10px;
  }

  .lineSearch {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .searchByMonth {
    width: 80%;
    display: flex;
    align-items: center;
    margin: 10px 0px 0px 0px;
  }

  .ContainerBtnFiscal {
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: auto;
    margin-top: 50px;
    width: 100%;
    padding: 0px 0px 5px 0px;
    border-bottom: none;
  }

  .BtnFiscal {
    width: 24%;
    height: 30px;
    font-size: 10px;
    box-shadow: none;
  }
  .ItemSummaryFiscal {
    width: 23%;
    height: 70px;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    font-weight: 100;
    font-size: 9px;
    box-shadow: none;
    cursor: pointer;
    align-items: flex-start;
    justify-content: space-evenly;
  }
  .ContainerSearchInput {
    display: none;
  }

  .searchContainer {
    display: flex;
    height: 90px;
    padding: 10px 0 0 0;
    gap: 10px;
    width: 100%;
    align-items: center;
    flex-direction: column;
    justify-content: center;
  }

  .btnPeriod {
    width: 70px;
    height: 30px;
  }

  .searchInput {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .ContentTable {
    padding: 5px;
  }
  .ModalGeneral {
    position: fixed !important;
    z-index: 900;
    top: 50px;
    left: 0;
    width: 100%;
  }

  .disable {
    width: 100%;
    height: 0;
    left: 0;
  }

  .sizeFiscal {
    width: 100vw !important;
    padding: 0 10px;
  }
  .btnActions {
    margin-left: 0px;
  }

  .actiontd {
    margin-right: 0px;
  }
}
@media screen and (max-width: 450px) {
  .sizeFiscal {
    width: 104vw;
    padding: 0 10px;
  }
}
</style>
